import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { GHL } from "./ghl";

// 全域錯誤處理
const app = createApp(App);

app.config.errorHandler = (err, vm, info) => {
  console.error('Vue error:', err, info);
  
  // 如果是嚴重錯誤，顯示 fallback UI
  if (err.name === 'ChunkLoadError' || err.message.includes('Loading chunk')) {
    document.getElementById('app').innerHTML = `
      <div style="text-align: center; padding: 2rem; font-family: Arial, sans-serif;">
        <h2>NewebPay 付款整合</h2>
        <p style="color: #dc3545;">資源載入失敗</p>
        <p style="font-size: 0.9rem; color: #666;">請重新整理頁面重試。</p>
        <button onclick="window.location.reload()" style="background: #007bff; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer;">重新載入</button>
      </div>
    `;
  }
};

// 初始化 GHL（只在非付款頁面）
const currentPath = window.location.pathname;
// 付款頁在 GHL 付款連結中通常以 iframe 方式載入到 link.fastpaydirect.com
// 在該情境下路徑可能是 '/'，因此需以 referrer 與 iframe 狀態輔助判斷
const referrer = document.referrer || '';
const inIframe = window !== window.parent;
const isGhlPaymentReferrer = /fastpaydirect\.com|leadconnectorhq\.com/i.test(referrer);
const isPaymentPage = (
  currentPath.includes('/checkout') ||
  currentPath.includes('/newebpay') ||
  currentPath.includes('/payment-return') ||
  currentPath.includes('/payment-method-return') ||
  currentPath.includes('/add-payment-method') ||
  currentPath.includes('/customer-return') ||
  currentPath.includes('/subscription/return') ||
  // 於 GHL 付款連結 iframe 中載入本頁
  (inIframe && isGhlPaymentReferrer)
);

console.log("Current path in main.js:", currentPath);
console.log("Is payment page in main.js:", isPaymentPage);

if (!isPaymentPage) {
  const ghl = new GHL();
  window.ghl = ghl;
  console.log("GHL instance created for non-payment page");
} else {
  // 為付款頁面提供一個空的 ghl 對象，避免錯誤
  window.ghl = {
    getUserData: () => {
      console.log("getUserData() skipped on payment page");
      return Promise.reject(new Error("getUserData not available on payment page"));
    }
  };
  console.log("Mock GHL instance created for payment page");
  // 若目前非付款路徑，導向到前端結帳頁（讓該頁監聽 postMessage）
  if (!currentPath.includes('/newebpay/checkout') &&
      !currentPath.includes('/checkout') &&
      !currentPath.includes('/add-payment-method') &&
      !currentPath.includes('/payment-method-return')) {
    try {
      router.push('/newebpay/checkout');
    } catch (_) {
      // 忽略重複導向錯誤
    }
  }
}

// 添加全域屬性以便組件使用
app.config.globalProperties.$isMarketplacePreview = () => {
  return window.location.href.includes('marketplace') || 
         window.location.href.includes('preview') ||
         window.parent !== window;
};

app.use(router);

// 確保 DOM 準備好後再掛載
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    app.mount('#app');
  });
} else {
  app.mount('#app');
}

// 移除 fallback 內容
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const fallbackElements = document.querySelectorAll('.fallback');
    fallbackElements.forEach(el => {
      if (el.parentNode && el.parentNode.id !== 'app') {
        el.remove();
      }
    });
  }, 1000);
});
